/*
 * The first Play used to wait for two downloads in a row: the Stormcloud player script and the
 * Google IMA ad SDK it loads. While the page is idle (or when the pointer reaches Play) we add both
 * script tags the same way the player would; the player then finds them already loaded:
 *   - VideoPlayerPageComponent.loadStormcloudScript reuses any script[src*="stormcloud"]
 *   - Stormcloud reuses script[data-ima="true"] / window.google.ima
 * Loading the SDK does not request ads; that only happens when the player starts.
 */
import { STORMCLOUD_SCRIPT_URL } from '../video-player-page/stormcloud-script';

export const IMA_SDK_URL = 'https://imasdk.googleapis.com/js/sdkloader/ima3.js';

function addScript(doc: Document, src: string, attrs: Record<string, string> = {}): void {
  const script = doc.createElement('script');
  script.src = src;
  script.async = true;
  Object.entries(attrs).forEach(([name, value]) => script.setAttribute(name, value));
  doc.head.appendChild(script);
}

/** Adds the player and ad SDK scripts unless the page already has them. Safe to call many times. */
export function warmUpPlayer(doc: Document = document): void {
  const win: any = doc.defaultView || {};
  if (!win.StormcloudVP && !doc.querySelector('script[src*="stormcloud"]')) addScript(doc, STORMCLOUD_SCRIPT_URL);
  if (!win.google?.ima && !doc.querySelector('script[data-ima="true"]')) addScript(doc, IMA_SDK_URL, { 'data-ima': 'true' });
}

/** Runs warmUpPlayer when the browser is idle, so it never competes with the page's own loading. */
export function warmUpPlayerWhenIdle(doc: Document = document): void {
  const win: any = doc.defaultView;
  if (!win) return;
  const run = () => warmUpPlayer(doc);
  if (typeof win.requestIdleCallback === 'function') win.requestIdleCallback(run, { timeout: 4000 });
  else win.setTimeout(run, 2000);
}
